// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 70,
  },
  subContainer: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down(850)]: {
      width: '80%',
      marginTop: 15,
    },
    [theme.breakpoints.down(750)]: {
      width: '95%',
    },
  },
  title: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    width: 'fit-content',
    margin: '0 auto 20px auto',
  },
  textContainer: {
    margin: '10px 0',
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
  },
  helpersContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
    width: 850,
    flexDirection: 'column',
    [theme.breakpoints.down(850)]: {
      width: '95%',
    }
  },
  image: {
    maxWidth: '80%',
    marginTop: 20,
  },
  imageTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
  },
  mainText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
    marginTop: 20,
    marginBottom: 30,
    maxWidth: '80%',
  },
});

export default styles;
